/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions } from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions';
import {
    instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSON,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON,
} from './FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions';

/**
 * @type FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions
 * 
 * @export
 */
export type FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions = FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions;

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSON(json: any): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(json)) {
        return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSON(json: any): any {
    return FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSONTyped(json, false);
}

export function FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptionsToJSONTyped(value?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdResponseTransferOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions(value)) {
        return FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptionsToJSON(value as FxIdApplicationHandlersAuthAuthenticateWithExternalIdAuthenticateWithExternalIdResultTransferOptions);
    }

    return {};
}

